module.exports = __webpack_public_path__ + "img/usd_circle.19fa51eb.svg";